import * as React from "react";
import {TextField, Box, IconButton, Dialog, DialogTitle, Button, styled, Divider, Tooltip, makeStyles} from "@material-ui/core";

import {  DateRangePickerDay as MuiDateRangePickerDay } from "@mui/lab";
import {
  StaticDateRangePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers-pro";
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { sv } from "date-fns/locale";
import { AdapterDateFns, } from '@mui/x-date-pickers/AdapterDateFns';
import {Check, Close} from '@material-ui/icons'
import moment from 'moment'
import {isNull} from 'lodash'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import IntlMessages from 'util/IntlMessages';
import { injectIntl } from 'react-intl';
const useStyles = makeStyles(theme => ({
  dayRoot: {
    '&$selected, &$selected:hover, &$selected:focus': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  menuItemSelected: {}
}));

const DateRangePickerDay = styled(MuiDateRangePickerDay)(
  ({
    theme,
    isHighlighting,
    isStartOfHighlighting,
    isEndOfHighlighting,
    outsideCurrentMonth,
  }) => ({
    ...(!outsideCurrentMonth &&
      isHighlighting && {
        // borderRadius: 0,
        // backgroundColor: theme.palette.primary.main,
        // color: theme.palette.common.white,
        // '&:hover, &:focus': {
          // backgroundColor: theme.palette.primary.dark,
        // },
      }),
    ...(isStartOfHighlighting && {
      backgroundColor: theme.palette.primary.main,
      borderTopLeftRadius: '50%',
      borderBottomLeftRadius: '50%',
    }),
    ...(isEndOfHighlighting && {
      backgroundColor: theme.palette.primary.main,
      borderTopRightRadius: '50%',
      borderBottomRightRadius: '50%',
    }),
  }),
);


function BasicDateRangePicker(props) {
  const [value, setValue] = React.useState([null, null]);
  const [open, setOpen] = React.useState(false)
  const classes = useStyles()
  const FromInput = props.intl.formatMessage({ id: 'Input.From' });
  const ToInput = props.intl.formatMessage({ id: 'Input.To' });
  React.useEffect(() => {
      const hideLicenseBanner = () => {
        const targetDiv = Array.from(document.querySelectorAll("div")).find((el) =>
          el.textContent.trim() === "MUI X: Missing license key"
        );
        if (targetDiv) {
          targetDiv.style.display = "none";
        }
      };
  
      // Run once and then check every 500ms in case MUI injects it later
      hideLicenseBanner();
      const interval = setInterval(hideLicenseBanner, 50);
      return () => clearInterval(interval);
    }, []);
  const handleChangeDate = (newValue) => {
    console.log(newValue)
    setValue(newValue)
  }
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = (e) => {
    e.currentTarget.blur()
    setOpen(true)
  }

  const renderWeekPickerDay = (date, dateRangePickerDayProps) => {
    return <DateRangePickerDay {...dateRangePickerDayProps} />;
  };

  const handleSetLast30Days = () => {
    setValue([moment().subtract(30, 'days'), moment()])
  }
  const handleSetLastMonth = () => {
    setValue([moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')])
  }
  const handleSetLast3Month = () => {
    setValue([moment().subtract(3, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')])
  }
  const handleSetThisYear = () => {
    setValue([moment().startOf('year'), moment().endOf('year')])
  }
  const handleSetLastYear = () => {
    setValue([moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')])
  }
  const handleSetAllt = () => {
    setValue(["Allt", "Allt"])
  }
  const handleAddDate = () => {
    setOpen(false)
    props.handleChange(
      `${props.Meta}To`,
      isNull(value[1]) ? moment().format('YYYY-MM-DD') :value[1] === "Allt"?"Allt": moment(value[1]).format('YYYY-MM-DD'), 
      `${props.Meta}From`,
      isNull(value[0]) ? moment().format('YYYY-MM-DD') :value[0] === "Allt"?"Allt": moment(value[0]).format('YYYY-MM-DD')
    )
  }

  return (
    <>
      <Box display="flex" p={0} m={0} mb={1} style={{ width:"100%" }} alignItems="start">
        <Box p={0} flexGrow={1}>
          <MuiPickersUtilsProvider locale={sv} utils={DateFnsUtils}>
            <>
              <KeyboardDatePicker
                fullWidth
                defaultValue=""
                inputVariant="outlined"
                invalidDateMessage={<IntlMessages id="Date.inValid"/>}
                variant="inline"
                format="yyyy-MM-dd"
                size="small"
                cancelLabel={<IntlMessages id="Cancel"/>}
                name="title"
                // onClick={handleOpen}
                // onFocus={handleOpen}
                onChange={(date) => setValue(state => ([date, state[1]]))}
                label={<>{props.Label} {FromInput}</>}
                value={isNull(value[0]) ? moment() : value[0] === "Allt"?moment():value[0]}
                InputLabelProps={{ shrink: true, style: {whiteSpace: 'nowrap'} }}
                KeyboardButtonProps={{
                  "class": "px-0 m-0 btn btn-sm d-none",
                }}
                />
              </>
            </MuiPickersUtilsProvider>
          </Box> 
          <Box p={0}>  
            <b className="d-flex justify-content-center mx-3" style={{ margin: '0', fontSize: 22, paddingTop: 2 }}>-</b>
          </Box> 
          <Box p={0} flexGrow={1}>
            <MuiPickersUtilsProvider locale={sv} utils={DateFnsUtils}>
              <>
                <KeyboardDatePicker
                  fullWidth
                  defaultValue=""
                  invalidDateMessage={<IntlMessages id="Date.inValid"/>}
                  format="yyyy-MM-dd"
                  inputVariant="outlined"
                  variant="inline"
                  size="small"
                  cancelLabel={<IntlMessages id="Cancel"/>}
                  name="title"
                  // onClick={handleOpen}
                  // onFocus={handleOpen}
                  onChange={(date) => setValue(state => ([state[0], date]))}
                  label={<>{props.Label} {ToInput}</>}
                  value={isNull(value[1]) ? moment() : value[1] === "Allt"?moment():value[1]}
                  InputLabelProps={{ shrink: true,  style: {whiteSpace: 'nowrap'} }}
                  KeyboardButtonProps={{
                    "class": "px-0 m-0 btn btn-sm d-none"
                  }}
                />
              </>
            </MuiPickersUtilsProvider>
          </Box> 
          <Box px={1}  style={{paddingTop: 4}}>  
          <Tooltip title={<IntlMessages id="Choose.Date.Range"/>}>
            <IconButton
              color="primary"
              aria-label="upload picture"
              component="span"
              onClick={handleOpen}
              size="small"
            >
              <CalendarMonthIcon />
            </IconButton>
          </Tooltip>
        </Box> 
          <Box pr={1} style={{paddingTop: 4}}>  
          <Tooltip title={<IntlMessages id="Add"/>}>
            <IconButton
              color="primary"
              aria-label="upload picture"
              component="span"
              onClick={handleAddDate}
              size="small"
            >
              <Check />
            </IconButton>
          </Tooltip>
        </Box> 
      </Box>
      <Dialog onClose={handleClose} open={open} maxWidth="unset">
        <div className="d-flex align-items-center justify-content-between w-100">
          <DialogTitle><IntlMessages id="Choose"/> {String(props.Label).toLowerCase()}</DialogTitle>
          {
            (!isNull(value[0]) && !isNull(value[1])) && 
            <DialogTitle>
              {
                value[0]==='Allt'?
                <span><IntlMessages id="Label.all.All"/></span>
                :
                <>
                <span>{isNull(value[0]) ? 'YYYY-MM-DD' : moment(value[0]).format('YYYY-MM-DD')}</span>
                <span className="mx-2"><IntlMessages id="Title.probability.Update2"/></span>
                <span>{isNull(value[1]) ? 'YYYY-MM-DD' : moment(value[1]).format('YYYY-MM-DD')}</span>
                </>  
              }
              
            </DialogTitle>
          }
          <IconButton onClick={() => setOpen(false)} style={{marginRight: 12, marginLeft:100}}>
            <Close/>
          </IconButton>
        </div>
        <Divider/>
        <Box display="flex">
          <Box>
           <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={sv}>
             <StaticDateRangePicker
               displayStaticWrapperAs="desktop"
               startText="Check-in"
               endText="Check-out"
               value={[
                 value[0] ? moment(value[0]).toDate() : null,
                 value[1] ? moment(value[1]).toDate() : null,
               ]}
               onChange={handleChangeDate}
               renderInput={(startProps, endProps) => (
                 <>
                   <TextField {...startProps} />
                   <TextField {...endProps} />
                 </>
               )}
             />
           </LocalizationProvider>
          </Box>
          <Box display="flex" flexDirection="column" mr={3} pt={2} pl={1}>
            <Button style={{justifyContent: "flex-start"}} size="small" color="primary" onClick={handleSetLast30Days}><IntlMessages id="Date.Option1"/></Button>
            <Button style={{justifyContent: "flex-start"}} size="small" color="primary" onClick={handleSetLastMonth}><IntlMessages id="Date.Option2"/></Button>
            <Button style={{justifyContent: "flex-start"}} size="small" color="primary" onClick={handleSetLast3Month}><IntlMessages id="Date.Option3"/></Button>
            <Button style={{justifyContent: "flex-start"}} size="small" color="primary" onClick={handleSetThisYear}><IntlMessages id="Date.Option4"/></Button>
            <Button style={{justifyContent: "flex-start"}} size="small" color="primary" onClick={handleSetLastYear}><IntlMessages id="Date.Option5"/></Button>
            {
              parseInt(props.withOutAll) ===1 ?
              <Button style={{justifyContent: "flex-start"}} size="small" color="primary" onClick={handleSetAllt}><IntlMessages id="Label.all.All" /></Button>
              :""
            }
          </Box>
        </Box>
        <Divider/>
        <div className="d-flex my-2 mr-2">
          <div className="ml-auto">
            <Button
            variant="contained"
            color="primary"
            className="jr-btn"
            onClick={handleAddDate} 
            ><IntlMessages id="Add"/>
            </Button>
          </div>  
        </div>
        {/* <div className="w-100 d-flex justify-content-end p-2 px-3">
          <Button size="small" color="primary" onClick={handleAddDate} variant="outlined"><IntlMessages id="Add"/></Button>
        </div> */}
      </Dialog>
    </>
  );
}
export default injectIntl(BasicDateRangePicker);
// import React, { useState } from "react"

// import { DateRangePicker, DateRange, LocalizationProvider } from "@material-ui/pickers"
// // import { MaterialUiPickersDate } from '@material-ui/pickers/src/typings/date';

// import moment from "moment"
// import MomentUtils from "@date-io/moment"

// export default function DateRangePicker() {
//     const locale = "en-gb"

//     const [selectedDate, handleDateChange] = React.useState([null, null])

//     return (
//         <div>
//             <LocalizationProvider dateLibInstance={moment} dateAdapter={MomentUtils} locale={locale}>
//                 <DateRangePicker
//                     toolbarTitle="Test test"
//                     startText="Check-in"
//                     endText="Check-out"
//                     value={selectedDate}
//                     onChange={(date) => handleDateChange(date)}
//                 />
//             </LocalizationProvider>
//         </div>
//     )
// }